window.addEventListener('DOMContentLoaded', (event) => {
  const hamburgerButton = document.querySelector(
    '.header__hamburger .hamburger'
  );
  const closeButton = document.querySelector('.header__hamburger .close');

  const mobileMenu = document.querySelector('.mobile-menu');

  const children = document.querySelectorAll('.mobile-menu .has-children');

  hamburgerButton.addEventListener('click', () => {
    hamburgerButton.classList.toggle('hide');
    closeButton.classList.toggle('hide');
    document.querySelector('body').style.overflow = 'hidden';
    mobileMenu.classList.add('mobile-menu--extended');
  });

  closeButton.addEventListener('click', () => {
    hamburgerButton.classList.toggle('hide');
    closeButton.classList.toggle('hide');
    document.querySelector('body').style.overflow = 'visible';
    mobileMenu.classList.remove('mobile-menu--extended');
  });

  children.forEach((child) => {
    child.querySelector('button.extend').addEventListener('click', () => {
      child.classList.toggle('has-children--extended');
    });
  });
});
